import React, { useEffect, useState } from "react";
import { View, Text, ActivityIndicator, StyleSheet } from "react-native";
import { useDispatch } from "react-redux";
import { supportAccessSuccess } from "../../OS/Login/State";
import { config } from "../../config";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { LoginNavigationParamList } from "@/src/OS/Login/navigation";
import { RouteProp } from "@react-navigation/native";

export function SupportAccessEntry({
  route,
}: {
  navigation: NativeStackNavigationProp<
    LoginNavigationParamList,
    "SupportAccessEntry"
  >;
  route: RouteProp<LoginNavigationParamList, "SupportAccessEntry">;
}) {
  const dispatch = useDispatch();
  const code = route.params?.code;
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!code) {
      setError("No exchange code provided");
      return;
    }

    (async () => {
      try {
        const response = await fetch(
          `${config.baseUrl}/support-access/exchange`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
          }
        );

        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          setError(data.error ?? `Exchange failed (${response.status})`);
          return;
        }

        const data = await response.json();

        dispatch(
          supportAccessSuccess({
            accessToken: data.access_token,
            sessionId: data.session_id,
            expiresAt: Date.now() / 1000 + data.expires_in,
            orgId: data.org_id ?? undefined,
            storeId: data.store_id ?? undefined,
            adminEmail: data.admin_email,
            adminName: data.admin_name ?? "Admin",
          })
        );
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "Failed to exchange code"
        );
      }
    })();
  }, [code, dispatch]);

  if (error) {
    return (
      <View style={styles.container}>
        <Text style={styles.errorTitle}>Support Access Failed</Text>
        <Text style={styles.errorMessage}>{error}</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" />
      <Text style={styles.loading}>Establishing support access...</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  loading: {
    marginTop: 16,
    fontSize: 16,
    color: "#666",
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: "700",
    color: "#dc2626",
    marginBottom: 8,
  },
  errorMessage: {
    fontSize: 14,
    color: "#666",
    textAlign: "center",
  },
});
